export default __webpack_public_path__ + "static/media/MT.b360b50c.svg";